import delete_message_reaction_by_pk from '@/client/exchanges/cacheExchange/optimistic/delete_message_reaction_by_pk';
import insert_message_one from '@/client/exchanges/cacheExchange/optimistic/insert_message_one';
import insert_message_reaction_one from '@/client/exchanges/cacheExchange/optimistic/insert_message_reaction_one';
import insert_rsvp_one from '@/client/exchanges/cacheExchange/optimistic/insert_rsvp_one';
import update_message_by_pk from '@/client/exchanges/cacheExchange/optimistic/update_message_by_pk';
import insert_chat_person_preference_one from './insert_chat_person_preference_one';

export default {
  delete_message_reaction_by_pk,
  insert_chat_person_preference_one,
  insert_message_one,
  insert_message_reaction_one,
  insert_rsvp_one,
  update_message_by_pk,
};
